import FlagIconsContainer from "../../Component/Icons/FlagIcons/FlagIconsContainer"

const FlagIcons = () => {
  return (
    <div className='page-body'>
      <FlagIconsContainer />
    </div>
  )
}

export default FlagIcons